export default __webpack_public_path__ + "static/media/AUSSIE_WEB.002ebf99.png";